import { useRequest } from 'ahooks';

import {
  Column,
  Footer,
  Form,
  Input,
  ScreenWarning,
  ButtonWithArrowRight,
} from '~components';
import { Representative } from '~services';
import { useTransshipment } from '~contexts/TranshipmentContext';

import { Values } from './types';
import * as Styled from './styled';
import validation from './validations';
import { formatNumberSpouse } from './formaters';
import { ChangeEvent, useState } from 'react';
import axios from 'axios';

function SpouseData() {
  const [cellphoneValue, setCellphoneValue] = useState('');
  const [spouseValue, setSpouseValue] = useState('');
  const transshipment = useTransshipment();
  const [emailErrorMessage, setEmailErrorMessage] = useState<string>();

  const { runAsync: createSpouse, loading: isLoadingCreateSpouse } = useRequest(
    Representative.createSpouse,
    {
      manual: true,
    }
  );

  const initialValue: Values = {
    name: '',
    cellphone: '',
    email: '',
  };

  async function handleSubmit(values: Values) {
    const newValue: Values = {
      ...values,
      cellphone: formatNumberSpouse(values.cellphone),
    };

    try {
      await createSpouse(transshipment.id, newValue);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const { code, field } = error.response.data;

        if (code === 1 && field === 'email') {
          setEmailErrorMessage('E-mail já utilizado, informe outro');
          return;
        }
      }
    }

    transshipment.nextStep();
  }

  const handleChangeCellphoneMask = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
      .replace(/\D/g, '')
      .slice(0, 11)
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d)(\d{4})$/, '$1-$2');
    setCellphoneValue(newValue);
  };

  const handleChangeSpouseValue = (event: ChangeEvent<HTMLInputElement>) => {
    const newSpouseValue = event.target.value.replace(/[^a-zA-Z\s]/g, '');
    setSpouseValue(newSpouseValue);
  };

  return (
    <Column>
      <Form<Values>
        initialValues={initialValue}
        onSubmit={handleSubmit}
        validationSchema={validation}
        aria-labelledby="form-spouse-data"
      >
        <Styled.Title>Dados do cônjuge</Styled.Title>
        <Styled.Description>
          Precisaremos do envio de documento e selfie do seu cônjuge para dar
          continuidade no seu cadastro como avalista
        </Styled.Description>
        <Styled.InputContainer>
          <Input
            name="name"
            value={spouseValue}
            label="Nome completo do cônjuge *"
            type="text"
            placeholder="Seu nome"
            maxLength={255}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleChangeSpouseValue(event)
            }
          />
        </Styled.InputContainer>
        <Styled.InputContainer>
          <Input
            name="cellphone"
            value={cellphoneValue}
            label="Celular do cônjuge *"
            placeholder="(00) 00000-0000"
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleChangeCellphoneMask(event)
            }
          />
        </Styled.InputContainer>
        <Styled.InputContainer>
          <Input
            name="email"
            label="E-mail do cônjuge *"
            type="text"
            placeholder="Seu e-mail"
            maxLength={50}
            externalError={emailErrorMessage}
          />
        </Styled.InputContainer>
        <ScreenWarning message="Um SMS será enviado para o seu cônjuge para dar continuidade no envio de dados" />
        <Footer
          marginTop="40px"
          havePaddingBottom
          rightButton={
            <ButtonWithArrowRight
              data-testid="send-sms"
              type="submit"
              variant="primary"
              width="100%"
              disabled={isLoadingCreateSpouse}
              loading={isLoadingCreateSpouse}
            >
              Continuar
            </ButtonWithArrowRight>
          }
        />
      </Form>
    </Column>
  );
}

export default SpouseData;
